import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import { useTranslation } from '@/i18n';
import { Drawer, Loading } from '@moneyforward/ap-frontend-components';
import { FC, memo, useCallback } from 'react';
import { ErrorDetailDrawerContent } from './ErrorDetailDrawerContent';

const ContentLoadingComponent = memo(() => {
  return (
    <div>
      <Loading size='large' />
    </div>
  );
});
ContentLoadingComponent.displayName = 'ContentLoadingComponent';

export const ErrorDetailDrawer: FC<{
  selectedId?: string;
  setSelectedId: (id: string | undefined) => void;
}> = memo(({ selectedId, setSelectedId }) => {
  const { t } = useTranslation();

  const onClose = useCallback(() => {
    setSelectedId(undefined);
  }, [setSelectedId]);

  const isVisible = selectedId !== undefined;

  return (
    <Drawer
      title={t('import_export_history_error_detail_title')}
      width='600px'
      visible={isVisible}
      onClose={onClose}
      mask
      maskClosable={false}
    >
      {selectedId !== undefined && (
        <SuspenseErrorBoundary fallback={<ContentLoadingComponent />}>
          <ErrorDetailDrawerContent id={selectedId} />
        </SuspenseErrorBoundary>
      )}
    </Drawer>
  );
});
ErrorDetailDrawer.displayName = 'ErrorDetailDrawer';
